import { render, staticRenderFns } from "./WithdrawRialDetail.html?vue&type=template&id=2fe9e408&scoped=true&"
import script from "./WithdrawRialDetail.js?vue&type=script&lang=js&"
export * from "./WithdrawRialDetail.js?vue&type=script&lang=js&"
import style0 from "./WithdrawRialDetail.scss?vue&type=style&index=0&id=2fe9e408&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9e408",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VIcon,VImg,VRow})
